<script>
    import { findInsights } from '../api/search';
    import SearchInput from "../components/SearchInput.vue";
    import SingleSelector from "../components/SingleSelector.vue";
    import MultiSelector from "../components/MultiSelector.vue";
    import { truncText, getTopAreaHeight } from "../utils/utils";
    import bus from "../utils/eventBus";
    import axios from 'axios';
    import { forEach as _forEach } from 'lodash';

    export default {
        components: {
            "search-input": SearchInput,
            "single-selector": SingleSelector,
            "multi-selector": MultiSelector
        },
        props: {
            language: { type: String, default: 'fi' },
            pageSize: { type: [String, Number], default: '12' },
            iconApiUrl: { type: String, default: '' },
            pagePurpose: { type: Object, default: () => ({}) },
            pageTaxonomy: { type: Object, default: () => ({}) },
            rootId: { type: Number, default: null },
            excludeIds: { type: Object, default: () => ({}) },
            openByDefault: { type: Boolean, default: false },
            matchAllTaxonomies: { type: Boolean, default: false },
            sortBy: { type: Number, default: 0 }
        },
        data() {
            return {
                bus: bus,
                initialSelectedFilters: [],
                selectedFilters: [],
                selectedPurpose: null,
                selectedSort: null,
                filtersShown: this.openByDefault,
                searchQuery: '',
                page: 1,
                hasResponse: false,
                hasResults: false,
                loading: false,
                showPagination: false,
                pagePurposeIcons: []
            };
        },
        provide() {
            return {
                parentBus: this.bus
            };
        },
        mounted() {
            if (this.bus && typeof this.bus.$on === 'function') {
                this.bus.$on('dropdownChange', (val, id) => {
                    if (id === 'purpose') {
                        this.selectedPurpose = val && val.id !== '-1' ? val.id : null;
                    }
                    else if (id === 'sort') {
                        this.selectedSort = val && val.id !== '-1' ? val.id : null;
                    }
                    this.onChange();
                });
            }
        },
        created() {        
            const query = this.currentQuery || {};
            if (query.p) {
                this.page = parseInt(query.p);
            }
            if (query.q) {
                this.searchQuery = query.q;
            }
            if (query.filters) {
                this.selectedFilters = query.filters;
            }
            if (query.purpose) {
                this.selectedPurpose = query.purpose;
            }
            if (query.sort) {
                this.selectedSort = query.sort;
            }

            window.addEventListener('click', (e) => {
                if (this.filtersShown) {
                    this.bus.$emit('hideOtherDropdowns', e.target);
                    if (e.pointerType === 'mouse') {
                        const liftupsParent = this.$el.querySelector('.liftuppagesblock');
                        const paginationParent = this.$el.querySelector('.pagination');
                        const searchInput = this.$el.querySelector('.searchInput');
                        const multiselectParent = this.$el.querySelectorAll('.multiSelect');
                        if ((!liftupsParent || (e.target !== liftupsParent && !liftupsParent.contains(e.target))) &&
                            (!paginationParent || (e.target !== paginationParent && !paginationParent.contains(e.target))) &&
                            (!searchInput || (e.target !== searchInput && !searchInput.contains(e.target)))) {
                            let clickOutside = true;
                            for (let i = 0; i < multiselectParent.length; i++) {
                                const $multiselect = $(multiselectParent[i]);
                                const multiselectOffset = $multiselect.offset();
                                const multiselectWidth = $multiselect.outerWidth();
                                const multiselectHeight = $multiselect.outerHeight();

                                if (
                                    e.pageX > multiselectOffset.left &&
                                    e.pageX < multiselectOffset.left + multiselectWidth &&
                                    e.pageY > multiselectOffset.top &&
                                    e.pageY < multiselectOffset.top + multiselectHeight
                                ) {
                                    clickOutside = false;
                                    break;
                                }
                            }
                            if (clickOutside) {
                                this.bus.$emit('hideOthers');
                            }
                        }
                    }
                }
            });
        },
        updated() {
            var params = {
                filters: this.selectedFilters,
                purpose: this.selectedPurpose,
                sort: this.selectedSort,
                q: this.searchQuery,
                p: this.page,
            }
            const query = this.currentQuery || {};
            // Allow campaign tracking queries
            if (query.utm_source) {
                params.utm_source = query.utm_source;
            }
            if (query.utm_medium) {
                params.utm_medium = query.utm_medium;
            }
            if (query.utm_campaign) {
                params.utm_campaign = query.utm_campaign;
            }
            if (query.utm_content) {
                params.utm_content = query.utm_content;
            }
            if (query.utm_term) {
                params.utm_term = query.utm_term;
            }

            this.$router.push({
                path: this.currentRoute.path || window.location.pathname,
                query: params
            }).catch(err => { });
        },
        computed: {
            currentRoute() {
                return (this.$router && this.$router.currentRoute) || {};
            },
            currentQuery() {
                if (this.currentRoute.query) {
                    return this.currentRoute.query;
                }
                const params = new URLSearchParams(window.location.search);
                const q = {};
                params.forEach((v, k) => { q[k] = v; });
                return q;
            },
            selectedFiltersCount: function () {
                let count = this.selectedFilters.length;
                if (this.selectedPurpose) {
                    count++;
                }
                if (this.selectedSort) {
                    count++;
                }
                return count;
            }
        },
        watch: {
            initialSelectedFilters: function() {
                this.selectedFilters = this.initialSelectedFilters;
            }
        },
        methods: {
            onChange() {
                this.search({
                    q: this.searchQuery,
                    page: 1,
                    take: this.pageSize,
                    sortBy: this.sortBy,
                    language: this.language,
                    filters: this.selectedFilters.toString(),
                    purpose: this.selectedPurpose,
                    sort: this.selectedSort,
                    pagePurposeIds: this.pagePurpose.toString(),
                    taxonomyIds: this.pageTaxonomy.toString(),
                    rootId: this.rootId,
                    excludeIds: this.excludeIds.toString(),
                    matchAllTaxonomies: this.matchAllTaxonomies
                })
            },
            search(params) {
                this.loading = true

                findInsights(params)
                    .then(response => {
                        this.page = 1;
                        this.response = response;
                        this.hasResponse = true;
                        this.hasResults = this.response.hits.length > 0;
                        this.showPagination = this.hasResults && response.totalPagingCount > 1 && this.page <= response.totalPagingCount;
                        if (this.hasResults) {
                            // Find all unique page-purpose icons names in response and store them
                            this.response.hits.forEach((item) => {
                                if (this.pagePurposeIcons.length === 0 || !this.pagePurposeIcons.find(({ name }) => name === item.pagePurposeIcon)) {
                                    if (item.pagePurposeIcon !== null) {
                                        this.pagePurposeIcons.push({ name: item.pagePurposeIcon });
                                    }
                                }
                            });
                            if (this.pagePurposeIcons.length > 0) {
                                // Go through all found unique page-purpose icons and load those not yet loaded. Set loading to false after last icon is loaded
                                this.pagePurposeIcons.forEach((item, index) => {
                                    if (!item.value) {
                                        return axios.get(this.iconApiUrl + 'Icon/?iconId=' + item.name).then(response => {
                                            item.value = response.data;
                                            if (index + 1 === this.pagePurposeIcons.length) {
                                                this.$nextTick(() => {
                                                    this.loading = false;
                                                });
                                            }
                                        });
                                    }
                                    else if (index + 1 === this.pagePurposeIcons.length) {
                                        this.loading = false;
                                    }
                                });
                            }
                            else {
                                this.loading = false;
                            }
                        }
                        else {
                            this.loading = false;
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.hasResponse = false;
                    })
            },
            toggleFilters() {
                this.filtersShown = !this.filtersShown;
            },
            onSearchInput(val, prevVal) {
                this.searchQuery = val;
                if (val === '' || val.length >= 3) {
                    this.onChange();
                }
            },
            onSelection(id) {
                this.selectedFilters.push(id);
                this.onChange();
            },
            onUnselection(id) {
                this.selectedFilters = this.selectedFilters.filter(item => item !== id);
                this.onChange();
            },
            onOpening(clickedItem) {
                this.bus.$emit('hideOthers', clickedItem);
                if (window.innerWidth <= 721) {
                    setTimeout(function(){
                        if ($(clickedItem.$el).hasClass('open')) {
                            $("html, body").animate({ scrollTop: $(clickedItem.$el).offset().top - getTopAreaHeight() }, 500);
                        }
                    }, 500);
                }
            },
            clearAll() {
                this.bus.$emit('clearAll');
                this.bus.$emit('clearAllDropdowns');
                this.selectedFilters = [];
                this.searchQuery = '';
                this.selectedPurpose = null;
                this.selectedSort = null;
                this.onChange();
            },
            renderTitle(rawTitle, titleLimit) {
                if (rawTitle && rawTitle.length > 1) {
                    return truncText(rawTitle, titleLimit);
                }
                else {
                    return rawTitle;
                }
            },
            renderIngress(rawIngress, ingressLimit) {
                if (rawIngress) {
                    if (rawIngress.length > 1) {
                        return truncText(rawIngress, ingressLimit);
                    }
                    else {
                        return rawIngress;
                    }
                }
                return '';
            },
            getPaginationLink(n) {
                let link = '?q=' + this.searchQuery + '&p=' + n;
                _forEach(this.selectedFilters, function(value) {
                    link += '&filters=' + value;
                });
                if (this.selectedPurpose) {
                    link += '&purpose=' + this.selectedPurpose;
                }
                if (this.selectedSort) {
                    link += '&sort=' + this.selectedSort;
                }
                
                return link;
            },
            getPaginationLinkPrev() {
                return this.getPaginationLink(parseInt(this.page)-1);
            },
            getPaginationLinkNext() {
                return this.getPaginationLink(parseInt(this.page)+1);
            },
            showPageLink(p) {
                return p == 1 || p == this.response.totalPagingCount || Math.abs(p - this.page) < 2;
            },
            showDots(p) {
                return Math.abs(p - this.page) === 2;
            },
            renderIcon(icon) {
                if (!icon) return null;
                return this.pagePurposeIcons.find(({ name }) => name === icon).value;
            },
            getButtonId(index) {
                return 'search-filters-button-' + index;
            },
            getDropdownId(index) {
                return 'search-filters-dropdown-' + index;
            }
        }
    };
</script>